import { Companion_getInstanceymhgfdhph325 as Companion_getInstance } from './HexFormat.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import { Companion_instance23tt71mgnug0i as Companion_instance } from '../collections/AbstractList.mjs';
import { charArray2ujmm1qusno00 as charArray } from '../js/arrays.mjs';
import {
  _Char___init__impl__6a9atx2gndcvjvc5pke as _Char___init__impl__6a9atx,
  Char__toInt_impl_vasixdnyockrdnmht5 as Char__toInt_impl_vasixd,
} from '../Char.mjs';
import {
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
} from '../exceptions.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../Unit.mjs';
import {
  concatToString2syawgu50khxi as concatToString,
  toCharArrayxsf0njqv61ha as toCharArray,
} from './stringJs.mjs';
import { toString1pkumu07cwy4m as toString } from '../js/coreRuntime.mjs';
import {
  fromInt2ii0rejb1w62w as fromInt,
  multiply2k9eolhnz1bjv as multiply,
  subtract2orl8z9upxd9l as subtract,
  add2suhfggl4zvkk as add,
  convertToInty04h231mmjoh as convertToInt,
  numberToLong2pakxeg38estk as numberToLong,
} from '../js/internal/longAsBigInt/longAsBigInt.mjs';
import {
  charCodeAt1yspne1d8erbm as charCodeAt,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
} from '../js/charSequenceJs.mjs';
import { numberRangeToNumber25vse2rgp6rs8 as numberRangeToNumber } from '../js/rangeTo.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../hacks.mjs';
import { ClosedRangehokgr73im9z3 as ClosedRange } from '../ranges/Range.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../js/typeCheckUtils.mjs';
import { contains2c50nlxg7en7o as contains } from '../ranges/_Ranges.mjs';
import {
  _ULong___init__impl__c78o9k4z3cjzifecv6 as _ULong___init__impl__c78o9k,
  ULong3f9k7s38t3rfp as ULong,
} from '../ULong.mjs';
import { numberToChar93r9buh19yek as numberToChar } from '../js/numberConversion.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function get_BYTE_TO_LOWER_CASE_HEX_DIGITS() {
  _init_properties_HexExtensions_kt__wu8rc3();
  return BYTE_TO_LOWER_CASE_HEX_DIGITS;
}
var BYTE_TO_LOWER_CASE_HEX_DIGITS;
function get_BYTE_TO_UPPER_CASE_HEX_DIGITS() {
  _init_properties_HexExtensions_kt__wu8rc3();
  return BYTE_TO_UPPER_CASE_HEX_DIGITS;
}
var BYTE_TO_UPPER_CASE_HEX_DIGITS;
function get_HEX_DIGITS_TO_DECIMAL() {
  _init_properties_HexExtensions_kt__wu8rc3();
  return HEX_DIGITS_TO_DECIMAL;
}
var HEX_DIGITS_TO_DECIMAL;
var HEX_DIGITS_TO_LONG_DECIMAL;
function toHexString(_this__u8e3s4, format) {
  format = format === VOID ? Companion_getInstance().sp_1 : format;
  _init_properties_HexExtensions_kt__wu8rc3();
  return toHexString_0(_this__u8e3s4, 0, _this__u8e3s4.length, format);
}
function toHexString_0(_this__u8e3s4, startIndex, endIndex, format) {
  startIndex = startIndex === VOID ? 0 : startIndex;
  endIndex = endIndex === VOID ? _this__u8e3s4.length : endIndex;
  format = format === VOID ? Companion_getInstance().sp_1 : format;
  _init_properties_HexExtensions_kt__wu8rc3();
  Companion_instance.xg(startIndex, endIndex, _this__u8e3s4.length);
  if (startIndex === endIndex) {
    return '';
  }
  var byteToDigits = format.up_1 ? get_BYTE_TO_UPPER_CASE_HEX_DIGITS() : get_BYTE_TO_LOWER_CASE_HEX_DIGITS();
  var bytesFormat = format.vp_1;
  if (bytesFormat.dq_1) {
    return toHexStringNoLineAndGroupSeparator(_this__u8e3s4, startIndex, endIndex, bytesFormat, byteToDigits);
  }
  return toHexStringSlowPath(_this__u8e3s4, startIndex, endIndex, bytesFormat, byteToDigits);
}
function toHexStringNoLineAndGroupSeparator(_this__u8e3s4, startIndex, endIndex, bytesFormat, byteToDigits) {
  _init_properties_HexExtensions_kt__wu8rc3();
  if (bytesFormat.eq_1) {
    return toHexStringShortByteSeparatorNoPrefixAndSuffix(_this__u8e3s4, startIndex, endIndex, bytesFormat, byteToDigits);
  }
  return toHexStringNoLineAndGroupSeparatorSlowPath(_this__u8e3s4, startIndex, endIndex, bytesFormat, byteToDigits);
}
function toHexStringSlowPath(_this__u8e3s4, startIndex, endIndex, bytesFormat, byteToDigits) {
  _init_properties_HexExtensions_kt__wu8rc3();
  var bytesPerLine = bytesFormat.xp_1;
  var bytesPerGroup = bytesFormat.yp_1;
  var bytePrefix = bytesFormat.bq_1;
  var byteSuffix = bytesFormat.cq_1;
  var byteSeparator = bytesFormat.aq_1;
  var groupSeparator = bytesFormat.zp_1;
  var formatLength = formattedStringLength(endIndex - startIndex | 0, bytesPerLine, bytesPerGroup, groupSeparator.length, byteSeparator.length, bytePrefix.length, byteSuffix.length);
  var charArray_0 = charArray(formatLength);
  var charIndex = 0;
  var indexInLine = 0;
  var indexInGroup = 0;
  var inductionVariable = startIndex;
  if (inductionVariable < endIndex)
    do {
      var byteIndex = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if (indexInLine === bytesPerLine) {
        var _unary__edvuaz = charIndex;
        charIndex = _unary__edvuaz + 1 | 0;
        charArray_0[_unary__edvuaz] = _Char___init__impl__6a9atx(10);
        indexInLine = 0;
        indexInGroup = 0;
      } else if (indexInGroup === bytesPerGroup) {
        charIndex = toCharArrayIfNotEmpty(groupSeparator, charArray_0, charIndex);
        indexInGroup = 0;
      }
      if (!(indexInGroup === 0)) {
        charIndex = toCharArrayIfNotEmpty(byteSeparator, charArray_0, charIndex);
      }
      charIndex = formatByteAt(_this__u8e3s4, byteIndex, bytePrefix, byteSuffix, byteToDigits, charArray_0, charIndex);
      indexInGroup = indexInGroup + 1 | 0;
      indexInLine = indexInLine + 1 | 0;
    }
     while (inductionVariable < endIndex);
  // Inline function 'kotlin.check' call
  if (!(charIndex === formatLength)) {
    throw IllegalStateException().o('Check failed.');
  }
  return concatToString(charArray_0);
}
function toHexStringShortByteSeparatorNoPrefixAndSuffix(_this__u8e3s4, startIndex, endIndex, bytesFormat, byteToDigits) {
  _init_properties_HexExtensions_kt__wu8rc3();
  var byteSeparatorLength = bytesFormat.aq_1.length;
  // Inline function 'kotlin.require' call
  // Inline function 'kotlin.require' call
  if (!(byteSeparatorLength <= 1)) {
    var message = 'Failed requirement.';
    throw IllegalArgumentException().n2(toString(message));
  }
  var numberOfBytes = endIndex - startIndex | 0;
  var charIndex = 0;
  if (byteSeparatorLength === 0) {
    // Inline function 'kotlin.Long.times' call
    var tmp$ret$3 = multiply(2n, fromInt(numberOfBytes));
    var charArray_0 = charArray(checkFormatLength(tmp$ret$3));
    var inductionVariable = startIndex;
    if (inductionVariable < endIndex)
      do {
        var byteIndex = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        charIndex = formatByteAt_0(_this__u8e3s4, byteIndex, byteToDigits, charArray_0, charIndex);
      }
       while (inductionVariable < endIndex);
    return concatToString(charArray_0);
  } else {
    // Inline function 'kotlin.Long.times' call
    // Inline function 'kotlin.Long.minus' call
    var this_0 = multiply(3n, fromInt(numberOfBytes));
    var tmp$ret$5 = subtract(this_0, fromInt(1));
    var charArray_1 = charArray(checkFormatLength(tmp$ret$5));
    var byteSeparatorChar = charCodeAt(bytesFormat.aq_1, 0);
    charIndex = formatByteAt_0(_this__u8e3s4, startIndex, byteToDigits, charArray_1, charIndex);
    var inductionVariable_0 = startIndex + 1 | 0;
    if (inductionVariable_0 < endIndex)
      do {
        var byteIndex_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var _unary__edvuaz = charIndex;
        charIndex = _unary__edvuaz + 1 | 0;
        charArray_1[_unary__edvuaz] = byteSeparatorChar;
        charIndex = formatByteAt_0(_this__u8e3s4, byteIndex_0, byteToDigits, charArray_1, charIndex);
      }
       while (inductionVariable_0 < endIndex);
    return concatToString(charArray_1);
  }
}
function toHexStringNoLineAndGroupSeparatorSlowPath(_this__u8e3s4, startIndex, endIndex, bytesFormat, byteToDigits) {
  _init_properties_HexExtensions_kt__wu8rc3();
  var bytePrefix = bytesFormat.bq_1;
  var byteSuffix = bytesFormat.cq_1;
  var byteSeparator = bytesFormat.aq_1;
  var formatLength = formattedStringLength_0(endIndex - startIndex | 0, byteSeparator.length, bytePrefix.length, byteSuffix.length);
  var charArray_0 = charArray(formatLength);
  var charIndex = 0;
  charIndex = formatByteAt(_this__u8e3s4, startIndex, bytePrefix, byteSuffix, byteToDigits, charArray_0, charIndex);
  var inductionVariable = startIndex + 1 | 0;
  if (inductionVariable < endIndex)
    do {
      var byteIndex = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      charIndex = toCharArrayIfNotEmpty(byteSeparator, charArray_0, charIndex);
      charIndex = formatByteAt(_this__u8e3s4, byteIndex, bytePrefix, byteSuffix, byteToDigits, charArray_0, charIndex);
    }
     while (inductionVariable < endIndex);
  return concatToString(charArray_0);
}
function formattedStringLength(numberOfBytes, bytesPerLine, bytesPerGroup, groupSeparatorLength, byteSeparatorLength, bytePrefixLength, byteSuffixLength) {
  _init_properties_HexExtensions_kt__wu8rc3();
  // Inline function 'kotlin.require' call
  // Inline function 'kotlin.require' call
  if (!(numberOfBytes > 0)) {
    var message = 'Failed requirement.';
    throw IllegalArgumentException().n2(toString(message));
  }
  var lineSeparators = (numberOfBytes - 1 | 0) / bytesPerLine | 0;
  // Inline function 'kotlin.run' call
  var groupSeparatorsPerLine = (bytesPerLine - 1 | 0) / bytesPerGroup | 0;
  // Inline function 'kotlin.let' call
  var it = numberOfBytes % bytesPerLine | 0;
  var bytesInLastLine = it === 0 ? bytesPerLine : it;
  var groupSeparatorsInLastLine = (bytesInLastLine - 1 | 0) / bytesPerGroup | 0;
  var groupSeparators = imul(lineSeparators, groupSeparatorsPerLine) + groupSeparatorsInLastLine | 0;
  var byteSeparators = ((numberOfBytes - 1 | 0) - lineSeparators | 0) - groupSeparators | 0;
  var formatLength = add(add(add(fromInt(lineSeparators), multiply(fromInt(groupSeparators), fromInt(groupSeparatorLength))), multiply(fromInt(byteSeparators), fromInt(byteSeparatorLength))), multiply(fromInt(numberOfBytes), add(add(fromInt(bytePrefixLength), 2n), fromInt(byteSuffixLength))));
  return checkFormatLength(formatLength);
}
function toCharArrayIfNotEmpty(_this__u8e3s4, destination, destinationOffset) {
  _init_properties_HexExtensions_kt__wu8rc3();
  switch (_this__u8e3s4.length) {
    case 0:
      break;
    case 1:
      destination[destinationOffset] = charCodeAt(_this__u8e3s4, 0);
      break;
    default:
      toCharArray(_this__u8e3s4, destination, destinationOffset);
      break;
  }
  return destinationOffset + _this__u8e3s4.length | 0;
}
function formatByteAt(_this__u8e3s4, index, bytePrefix, byteSuffix, byteToDigits, destination, destinationOffset) {
  _init_properties_HexExtensions_kt__wu8rc3();
  var offset = toCharArrayIfNotEmpty(bytePrefix, destination, destinationOffset);
  offset = formatByteAt_0(_this__u8e3s4, index, byteToDigits, destination, offset);
  return toCharArrayIfNotEmpty(byteSuffix, destination, offset);
}
function checkFormatLength(formatLength) {
  _init_properties_HexExtensions_kt__wu8rc3();
  // Inline function 'kotlin.ranges.contains' call
  var this_0 = numberRangeToNumber(0, 2147483647);
  if (!contains(isInterface(this_0, ClosedRange()) ? this_0 : THROW_CCE(), formatLength)) {
    // Inline function 'kotlin.toULong' call
    var tmp$ret$1 = _ULong___init__impl__c78o9k(formatLength);
    throw IllegalArgumentException().n2('The resulting string length is too big: ' + new (ULong())(tmp$ret$1));
  }
  return convertToInt(formatLength);
}
function formatByteAt_0(_this__u8e3s4, index, byteToDigits, destination, destinationOffset) {
  _init_properties_HexExtensions_kt__wu8rc3();
  var byte = _this__u8e3s4[index] & 255;
  var byteDigits = byteToDigits[byte];
  destination[destinationOffset] = numberToChar(byteDigits >> 8);
  destination[destinationOffset + 1 | 0] = numberToChar(byteDigits & 255);
  return destinationOffset + 2 | 0;
}
function formattedStringLength_0(numberOfBytes, byteSeparatorLength, bytePrefixLength, byteSuffixLength) {
  _init_properties_HexExtensions_kt__wu8rc3();
  // Inline function 'kotlin.require' call
  // Inline function 'kotlin.require' call
  if (!(numberOfBytes > 0)) {
    var message = 'Failed requirement.';
    throw IllegalArgumentException().n2(toString(message));
  }
  // Inline function 'kotlin.Long.plus' call
  // Inline function 'kotlin.Long.plus' call
  var this_0 = add(2n, fromInt(bytePrefixLength));
  // Inline function 'kotlin.Long.plus' call
  var this_1 = add(this_0, fromInt(byteSuffixLength));
  var charsPerByte = add(this_1, fromInt(byteSeparatorLength));
  // Inline function 'kotlin.Long.minus' call
  var this_2 = multiply(numberToLong(numberOfBytes), charsPerByte);
  var formatLength = subtract(this_2, fromInt(byteSeparatorLength));
  return checkFormatLength(formatLength);
}
function access$_get_HEX_DIGITS_TO_DECIMAL_$tHexExtensionsKt_n4nhcp() {
  return get_HEX_DIGITS_TO_DECIMAL();
}
var properties_initialized_HexExtensions_kt_h16sbl;
function _init_properties_HexExtensions_kt__wu8rc3() {
  if (!properties_initialized_HexExtensions_kt_h16sbl) {
    properties_initialized_HexExtensions_kt_h16sbl = true;
    var tmp = 0;
    var tmp_0 = new Int32Array(256);
    while (tmp < 256) {
      var tmp_1 = tmp;
      // Inline function 'kotlin.code' call
      var this_0 = charCodeAt('0123456789abcdef', tmp_1 >> 4);
      var tmp_2 = Char__toInt_impl_vasixd(this_0) << 8;
      // Inline function 'kotlin.code' call
      var this_1 = charCodeAt('0123456789abcdef', tmp_1 & 15);
      tmp_0[tmp_1] = tmp_2 | Char__toInt_impl_vasixd(this_1);
      tmp = tmp + 1 | 0;
    }
    BYTE_TO_LOWER_CASE_HEX_DIGITS = tmp_0;
    var tmp_3 = 0;
    var tmp_4 = new Int32Array(256);
    while (tmp_3 < 256) {
      var tmp_5 = tmp_3;
      // Inline function 'kotlin.code' call
      var this_2 = charCodeAt('0123456789ABCDEF', tmp_5 >> 4);
      var tmp_6 = Char__toInt_impl_vasixd(this_2) << 8;
      // Inline function 'kotlin.code' call
      var this_3 = charCodeAt('0123456789ABCDEF', tmp_5 & 15);
      tmp_4[tmp_5] = tmp_6 | Char__toInt_impl_vasixd(this_3);
      tmp_3 = tmp_3 + 1 | 0;
    }
    BYTE_TO_UPPER_CASE_HEX_DIGITS = tmp_4;
    var tmp_7 = 0;
    var tmp_8 = new Int32Array(256);
    while (tmp_7 < 256) {
      tmp_8[tmp_7] = -1;
      tmp_7 = tmp_7 + 1 | 0;
    }
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.text.forEachIndexed' call
    var index = 0;
    var indexedObject = '0123456789abcdef';
    var inductionVariable = 0;
    while (inductionVariable < charSequenceLength(indexedObject)) {
      var item = charSequenceGet(indexedObject, inductionVariable);
      inductionVariable = inductionVariable + 1 | 0;
      var _unary__edvuaz = index;
      index = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.code' call
      tmp_8[Char__toInt_impl_vasixd(item)] = _unary__edvuaz;
    }
    // Inline function 'kotlin.text.forEachIndexed' call
    var index_0 = 0;
    var indexedObject_0 = '0123456789ABCDEF';
    var inductionVariable_0 = 0;
    while (inductionVariable_0 < charSequenceLength(indexedObject_0)) {
      var item_0 = charSequenceGet(indexedObject_0, inductionVariable_0);
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      var _unary__edvuaz_0 = index_0;
      index_0 = _unary__edvuaz_0 + 1 | 0;
      // Inline function 'kotlin.code' call
      tmp_8[Char__toInt_impl_vasixd(item_0)] = _unary__edvuaz_0;
    }
    HEX_DIGITS_TO_DECIMAL = tmp_8;
    var tmp_9 = 0;
    var tmp_10 = new BigInt64Array(256);
    while (tmp_9 < 256) {
      tmp_10[tmp_9] = -1n;
      tmp_9 = tmp_9 + 1 | 0;
    }
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.text.forEachIndexed' call
    var index_1 = 0;
    var indexedObject_1 = '0123456789abcdef';
    var inductionVariable_1 = 0;
    while (inductionVariable_1 < charSequenceLength(indexedObject_1)) {
      var item_1 = charSequenceGet(indexedObject_1, inductionVariable_1);
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      var _unary__edvuaz_1 = index_1;
      index_1 = _unary__edvuaz_1 + 1 | 0;
      // Inline function 'kotlin.code' call
      tmp_10[Char__toInt_impl_vasixd(item_1)] = fromInt(_unary__edvuaz_1);
    }
    // Inline function 'kotlin.text.forEachIndexed' call
    var index_2 = 0;
    var indexedObject_2 = '0123456789ABCDEF';
    var inductionVariable_2 = 0;
    while (inductionVariable_2 < charSequenceLength(indexedObject_2)) {
      var item_2 = charSequenceGet(indexedObject_2, inductionVariable_2);
      inductionVariable_2 = inductionVariable_2 + 1 | 0;
      var _unary__edvuaz_2 = index_2;
      index_2 = _unary__edvuaz_2 + 1 | 0;
      // Inline function 'kotlin.code' call
      tmp_10[Char__toInt_impl_vasixd(item_2)] = fromInt(_unary__edvuaz_2);
    }
    HEX_DIGITS_TO_LONG_DECIMAL = tmp_10;
  }
}
//region block: exports
export {
  get_BYTE_TO_LOWER_CASE_HEX_DIGITS as get_BYTE_TO_LOWER_CASE_HEX_DIGITS2mrc5tv7dfn1l,
  access$_get_HEX_DIGITS_TO_DECIMAL_$tHexExtensionsKt_n4nhcp as access$_get_HEX_DIGITS_TO_DECIMAL_$tHexExtensionsKt_n4nhcp3w0it47gmcdf0,
  toHexString as toHexString5bhtjxqec7ow,
};
//endregion

//# sourceMappingURL=HexExtensions.mjs.map
